// extracted by mini-css-extract-plugin
module.exports = {"container":"TruncTextWithReadMore_container__8B6y5","textTruncated":"TruncTextWithReadMore_textTruncated__Ot27n","content":"TruncTextWithReadMore_content__t26A7"};